import React from 'react';
import { useSelector } from 'react-redux';

import {removeKebabCase} from 'hpstore-helpers';

const siteConfigSelector = ({siteConfig}) => siteConfig && siteConfig.blog && siteConfig.blog.ctaAbtest

function shouldRenderCTA(tags){
  if(!tags) return true;

  for(let tag of tags ){
    if(tagsWithoutCTA[tag]) return false;
  }

  return true;
}

const Cta = ({tags=[], hideCta}) => {
  const ctaAbtest = useSelector(siteConfigSelector) || {}
  const { tags: tagsMap,  tagsWithoutCTA } = ctaAbtest || {};
  if(!tagsMap || !tagsWithoutCTA || !hideCta || !shouldRenderCTA(tags)) return null;

  var ctaLink = siteConfig.blog.ctaAbtest.ctaLink;
  const normalizedTags = tags.map(t => removeKebabCase({ str: t }).replace(/\s+/g, '').toLowerCase()).join('');

  for(let key in tagsMap) {
    if(normalizedTags.indexOf(key) > -1) {
       ctaLink = tagsMap[key]
       break;
    }
  }

  return (
    <div className="hero-banner-cta-container">
      <div className="cta-text">Explore our products</div>
      <div className="cta">
        <a href={ctaLink} target="_blank">Buy</a>
      </div>
    </div>
  )
};

export default Cta;
